import { FC } from 'react'

import InputItem from '../../../../../components/InputItem'
import { sortDropdown } from '../../../../../shared/formFunctions'
import { IMaterialEmissionConfiguration } from '../types'

interface IDataOrigin {
  formik: any
  configuration: IMaterialEmissionConfiguration
}

// Food's Data origin tab minus Core Version Release (story 36911 removes it), plus the two free
// text fields Science uses to record which Ecoinvent process was used and why a proxy was taken.
export const DataOrigin: FC<IDataOrigin> = ({ formik, configuration }) => {
  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        name="Data Origin"
        description="Where this emission factor came from."
        type="select"
        onChange={formik.handleChange}
        formikName="dataOrigin"
        formik={formik}
        defaultValue={formik.values.dataOrigin ?? -1}
        options={sortDropdown(
          configuration.dataOrigins,
          formik.values.dataOrigin ?? -1,
          'description'
        )}
      />
      <InputItem
        name="External Source"
        description="The external source this factor was taken from, where applicable."
        type="input"
        onChange={formik.handleChange}
        formikName="externalSource"
        formik={formik}
        defaultValue={formik.values.externalSource ?? ''}
      />
      <InputItem
        name="Data origin comment"
        description="Record which Ecoinvent process this factor was taken from."
        type="text"
        onChange={formik.handleChange}
        formikName="dataOriginComment"
        formik={formik}
        defaultValue={formik.values.dataOriginComment ?? ''}
      />
      <InputItem
        name="Proxy note"
        description="If this record is being used as a proxy for other materials (e.g. one recycled plastic EF standing in for all recycled plastics), note what it's being used for and why here."
        type="text"
        onChange={formik.handleChange}
        formikName="proxyNote"
        formik={formik}
        defaultValue={formik.values.proxyNote ?? ''}
      />
    </div>
  )
}
